import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getJobById } from '../services/firestore';

const JobDetailsPage = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJob = async () => {
      setLoading(true);
      setError(null);
      try {
        const jobData = await getJobById(jobId);
        setJob(jobData);
      } catch (err) {
        setError('Job not found.');
      } finally {
        setLoading(false);
      }
    };
    fetchJob();
  }, [jobId]);

  if (loading) return <div className="loading-container"><p>Loading job details...</p></div>;
  if (error) return <div className="error-message">{error}</div>;
  if (!job) return null;

  return (
    <div className="job-details-page">
      <button className="btn btn-outline btn-sm" onClick={() => navigate(-1)}>&larr; Back</button>
      <div className="job-header">
        <h2>{job.title}</h2>
        <span className={`job-type ${job.duration}`}>{job.duration?.charAt(0).toUpperCase() + job.duration?.slice(1) || 'Job'}</span>
      </div>
      <div className="job-details">
        <p className="job-description">{job.description}</p>
        <div className="job-info">
          {job.startDate && (
            <p><strong>Period: </strong>{new Date(job.startDate).toLocaleDateString()}{job.endDate && ` to ${new Date(job.endDate).toLocaleDateString()}`}</p>
          )}
          {job.schedule && Object.keys(job.schedule).length > 0 && (
            <p><strong>Schedule: </strong>{Object.keys(job.schedule).map(day => {
              const { startTime, endTime } = job.schedule[day];
              if (startTime && endTime) {
                return `${day.charAt(0).toUpperCase() + day.slice(1)}: ${startTime} - ${endTime}`;
              }
              return null;
            }).filter(Boolean).join(', ')}</p>
          )}
          {job.hourlyRate && (
            <p><strong>Rate: </strong>${job.hourlyRate}/hour</p>
          )}
        </div>
        {(job.qualifications?.length > 0 || job.responsibilities?.length > 0) && (
          <div className="job-lists">
            {job.qualifications?.length > 0 && (
              <div className="job-qualifications">
                <h4>Qualifications</h4>
                <ul>
                  {job.qualifications.map((qualification, index) => (
                    <li key={index}>{qualification}</li>
                  ))}
                </ul>
              </div>
            )}
            {job.responsibilities?.length > 0 && (
              <div className="job-responsibilities">
                <h4>Responsibilities</h4>
                <ul>
                  {job.responsibilities.map((responsibility, index) => (
                    <li key={index}>{responsibility}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
        {job.requirements && (
          <div className="job-requirements">
            <h4>Additional Requirements</h4>
            <p>{job.requirements}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobDetailsPage; 